<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.76775 17.8078C8.37722 17.4173 8.37722 16.7841 8.76775 16.3936L13.1212 12.0401L8.76775 7.6866C8.37722 7.29607 8.37722 6.66291 8.76775 6.27239C9.15827 5.88186 9.79144 5.88186 10.182 6.27239L15.2426 11.333C15.6331 11.7235 15.6331 12.3567 15.2426 12.7472L10.182 17.8078C9.79144 18.1983 9.15827 18.1983 8.76775 17.8078Z"
      fill="currentColor"
    />
  </svg>
</template>
